import Main from '@/views/administracion/reportes/contrato/Main.vue';
import DefaultContrato from '@/views/administracion/contratos/contrato/Default.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import MainConvenios from '@/views/administracion/contratos/contrato/convenios/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainContratoReporteFisico from '@/views/administracion/ejecucion/contrato/reportes/Main.vue';
import MainEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Default.vue';
import MainAlbum from '@/views/administracion/ejecucion/contrato/album/Main.vue';
import MainFianzas from '@/views/administracion/contratos/contrato/fianzas/Main.vue';
import MainActividades from '@/views/administracion/contratos/contrato/actividades/Main.vue';
import MainExpediente from '@/views/administracion/contratos/contrato/expediente/Main.vue';
import MainContratoVideos from '@/views/administracion/contratos/contrato/contratovideos/Main.vue';

const auth = ['Contratos:ver'];
const scopes = ['Contratos:crear', 'Contratos:editar', 'Contratos:eliminar'];

const contrato = [
  {
    path: 'contrato/:idContrato',
    meta: {
      title: 'Contrato',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'consultasContratoDefault',
        path: '/',
        meta: {
          title: 'Generales',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: DefaultContrato,
      },
      {
        name: 'consultasContratoAnticipos',
        path: 'anticipos',
        meta: {
          title: 'Anticipos',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainAnticipos,
      },
      {
        name: 'consultasContratoConveniosModificatorios',
        path: 'convenios',
        meta: {
          title: 'Convenios modificatorios',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainConvenios,
      },
      {
        name: 'consultasContratoPrograma',
        path: 'programa',
        meta: {
          title: 'Programa',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainPrograma,
      },
      {
        name: 'consultasContratoCatalogo',
        path: 'catalogo',
        meta: {
          title: 'Catálogo',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainCatalogo,
      },
      {
        name: 'consultasContratoEjecucionReportes',
        path: 'reportes',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContratoReporteFisico,
      },
      {
        name: 'consultasContratoEjecucionEstimaciones',
        path: 'estimaciones',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainEstimaciones,
        props: {
          soloLectura: true,
        },
      },
      {
        name: 'consultasContratoAlbum',
        path: 'album',
        meta: {
          title: 'Album Fotográfico',
          auth,
          scopes,
        },
        component: MainAlbum,
        props: {
          modulo: 'consultas',
        },
      },
      {
        name: 'consultaContratoVideos',
        path: 'consulta-videos',
        meta: {
          title: 'Consulta-Videos',
          auth,
          scopes,
        },
        component: MainContratoVideos,
        props: {
          soloLectura: true,
        },
      },
      {
        name: 'consultasContratoFianzas',
        path: 'fianzas',
        meta: {
          title: 'Fianzas',
          auth,
          scopes,
        },
        component: MainFianzas,
      },
      {
        name: 'consultasContratoActividades',
        path: 'actividades',
        meta: {
          title: 'Actividades',
          auth,
        },
        component: MainActividades,
      },
      {
        name: 'consultasContratoExpediente',
        path: 'expediente',
        meta: {
          title: 'Expediente',
          auth,
          scopes,
        },
        component: MainExpediente,
      },
    ],
  },
];

export default contrato;
